/*@ngInject*/
const FormTemplateRepository = function ($cacheFactory, $http, $q, baseCachedRepository) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'formTemplateRepository';
    };

    this.getCacheCapacity = function () {
        return 25;
    };

    this.loadUIFormTemplates = function (formTemplateIdList) {
        let templateIds = '',
            url,
            cachedUIFormTemplates = [],
            cache = $cacheFactory.get(this.getCacheName());

        if (!cache) {
            cache = $cacheFactory(this.getCacheName(), {capacity: this.getCacheCapacity()});
        }

        // Find out which uiFormTemplates are already cached.
        _.each(formTemplateIdList, function (formTemplateId) {
            if (cache.get(formTemplateId)) {
                cachedUIFormTemplates.push(cache.get(formTemplateId));
            } else {
                templateIds += 'formTemplateId=' + formTemplateId + '&';
            }
        });

        function onSuccess(response) {
            let uiFormTemplateList = [],
                unorderedUiFormTemplateList = [];

            if (response) {
                unorderedUiFormTemplateList = this.processResponseData(response.data);

                _.each(unorderedUiFormTemplateList, function (uiFormTemplate) {
                    cache.put(uiFormTemplate.formTemplate.id, uiFormTemplate);
                });

                unorderedUiFormTemplateList = _.concat(unorderedUiFormTemplateList, cachedUIFormTemplates);

                // Order the returned list of UIFormTemplate objects such that they match the order of the
                // inputted formTemplateIdList
                _.each(formTemplateIdList, function (formTemplateId) {
                    uiFormTemplateList.push(_.find(unorderedUiFormTemplateList, function (uiFormTemplate) {
                        return uiFormTemplate.formTemplate.id === formTemplateId;
                    }));
                });

                return $q.resolve(uiFormTemplateList);
            } else {
                return $q.reject();
            }
        }

        function onError(errorResponse) {
            return $q.reject(errorResponse.data);
        }

        if (_.isEmpty(templateIds)) {
            // If all are cached, then return them immediately.
            return $q.resolve(cachedUIFormTemplates);
        }

        // If any are not cached, then retrieve them from the server.
        url = '/rest/UIFormTemplate/Array?' + templateIds;
        return $http.get(url).then(onSuccess.bind(this), onError);
    };
};

angular.module('umFormViewer')
    .service('formTemplateRepository', FormTemplateRepository);
